export const camelToTitleCase = text => {
  return text
    .replace(/([A-Z]|^[a-z])/g, match => ` ${match.toUpperCase()}`)
    .trim()
}
